import request from "@/utils/request";

export default {
  findListPage: (param) => {
    return request({
      url: `/qspiQip/findListPage`,
      method: "post",
      data: param,
    });
  },
  getMonthRiskGrade: () => {
    return request({
      url: `/qspiQip/getMonthRiskGrade`,
      method: "get",
    });
  },
  updateQip: (param) => {
    return request({
      url: `/qspiQip/updateQip`,
      method: "post",
      data: param,
    });
  },
  updateBatchQipStatus: (param) => {
    return request({
      url: `/qspiQip/updateBatchQipStatus`,
      method: "post",
      data: param,
    });
  },
  // 根据产品编号、月份获取默认承认商
  getRelatedCarrier: (eightBitCode,month,dcCode) => {
    return request({
      url: `/qspiQip/${eightBitCode}/${month}/${dcCode}`,
      method: "post",
      data: {},
    });
  },
  updateBatchQip: (param) => {
    return request({
      url: `/qspiQip/updateBatchQip`,
      method: "post",
      data: param,
    });
  },
  // 获取承运商
  getCarrier: (param) => {
    return request({
      url: `/supplier/search`,
      method: "post",
      data: param,
    });
  },
  getQspiDcList: (param) => {
    return request({
      url: `/qspiDc/qspiDcList`,
      method: "post",
      data: param,
    });
  },
  // 获取用户管理中QIP_DC  adminconsole/dc/dCMasterData 
  getDcMasterData: (param) => {
    return request({
      url: `/dc/dCMasterData`,
      method: "post",
      data: param,
    });
  },
  getCategory: (param) => {
    return request({
      url: `/category/findCategory`,
      method: "post",
      data: param,
    });
  },
  delBatchQip: (param) => {
    return request({
      url: `/qspiQip/delBatchQip`,
      method: "post",
      data: param,
    });
  },
  updateBatchQipStatus: (param) => {
    return request({
      url: `/qspiQip/updateBatchQipStatus`,
      method: "post",
      data: param,
    });
  },
  // 新增时获取id
  getPrimaryKey: () => {
    return request({
      url: `/qspiQip/getPrimaryKey`,
      method: "get",
    });
  },
  dqmpDownload: (param) => {
    return request({
      url: `/qspiQip/qipDownload`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  qipTemplateDownload: (param) => {
    return request({
      url: `/qspiQip/qipTemplateDownload`,
      data: param,
      method: "get",
      responseType: "blob",
      fullResponse: true,
    });
  },
  //文件上传
  batchFileUpload: (data) => {
    return request({
      url: "/qspiQip/qipImportExcel",
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data; charset=UTF-8",
      },
      data: data,
    });
  },
};
